import { Injectable, inject } from '@angular/core';
import { IDEAApiService, IDEAStorageService, IDEATranslationsService } from '@idea-ionic/common';
import { IDEAAuthService, LoginOutcomeActions } from '@idea-ionic/auth';
const AUTH_TOKEN_STORAGE_KEY = 'authToken';

import { AppStore } from './app.store';
import { AlertController } from '@ionic/angular/standalone';
import { User } from '@models/user.model';
import { Section } from '@models/section.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private storage = inject(IDEAStorageService);
  private api = inject(IDEAApiService);
  private auth = inject(IDEAAuthService);
  public app = inject(AppStore);
  // private t = inject(IDEATranslationsService);
  // private alertCtrl = inject(AlertController);

  /**
   * Save the authentication token in the storage.
   */
  async saveAuthToken(token: string): Promise<void> {
    await this.storage.set(AUTH_TOKEN_STORAGE_KEY, token);
    this.api.authToken = token;
  }
  /**
   * Load the authentication token from the storage.
   */
  async loadAuthToken(): Promise<string> {
    const token = await this.storage.get(AUTH_TOKEN_STORAGE_KEY);
    this.api.authToken = token;
    return token;
  }

  /**
   * Sign into Cognito.
   */
  async cognitoSignIn(email: string, password: string): Promise<LoginOutcomeActions> {
    return await this.auth.login(email.toLowerCase(), password);
  }

  async confirmNewPassword(newPassword) {
    await this.auth.confirmNewPassword(newPassword);
  }
  async doAuth(): Promise<void> {
    const authUser = await this.auth.isAuthenticated(false, freshIdToken =>
      this.storage.set('authToken', freshIdToken)
    );

    await this.storage.set('authToken', authUser.idToken);
    this.api.authToken = await this.storage.get('authToken');
    const user = new User(await this.api.getResource(['users', authUser.userDetails.sub]));
    const section = new Section(await this.api.getResource(['sections', user.sectionId]));
    this.app.loadUser(user);
    this.app.loadSection(section);
  }

  // /**
  //  * Start the flow to sign-up with Cognito.
  //  */
  // async cognitoSignUp(email: string, password: string, firstName: string, lastName: string): Promise<void> {
  //   const body = { action: 'SIGN_UP', email, password, firstName, lastName };
  //   const { token } = await this.api.postResource('cognito', { body });
  //   await this.saveAuthToken(token);
  // }
  /**
   * Start the flow to reset the Cognito password.
   */
  async resetPassword(email: string): Promise<void> {
    const body = { action: 'RESET_PASSWORD', email };
    await this.api.postResource('cognito', { body });
  }
  /**
   * Complete the flow to reset the Cognito password.
   */
  async resetPasswordConfirm(email: string, password: string, confirmationCode: string): Promise<void> {
    const body = {
      action: 'RESET_PASSWORD_CONFIRM',
      email,
      password,
      confirmationCode
    };
    await this.api.postResource('cognito', { body });
  }

  /**
   * Sign-out the current user.
   */
  async logout(): Promise<void> {
    this.app.logout();
    this.auth.logout();
    await this.storage.clear();
    window.location.assign('');
  }
}
